import React, { Component } from "react";

export default class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;

    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const { message } = this.state;
    const subject = "Project inquiry for Víctor Cedeño";
    const mailtoUrl = `mailto:contacto@victorcedeno.mx?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;

    window.location.assign(mailtoUrl);
  }

  render() {
    const { message } = this.state;

    return (
      <section
        id="contact"
        className="colorlib-contact"
        data-section="contact"
      >
        <div className="colorlib-narrow-content">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
              data-animate-effect="fadeInLeft"
            >
              <span className="heading-meta">Contact</span>
              <h2 className="colorlib-heading">Let's work together</h2>
            </div>
          </div>
          <div className="row">
            <div
              className="col-md-12 animate-box"
              data-animate-effect="fadeInLeft"
            >
              <p className="contact-intro">
                Have a project in mind or need an experienced mobile engineer
                for your team? Tell me about your idea, goals, and technical
                needs. I’d be happy to discuss how I can help bring it to life.
              </p>
            </div>
          </div>
          <div className="row">
            <div
              className="col-md-12 animate-box"
              data-animate-effect="fadeInLeft"
            >
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label className="sr-only" htmlFor="contact-message">
                    Message
                  </label>
                  <textarea
                    id="contact-message"
                    className="form-control"
                    name="message"
                    value={message}
                    onChange={this.handleChange}
                    placeholder="Message"
                    rows="7"
                    required
                  />
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-primary btn-send-message"
                    type="submit"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
